import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { commonFeedActions } from '../../actions'
import FeedsTabContent from '../..'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import { redirectToPage } from 'srcReact/helpers/history'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { commonActions } from 'srcReact/components/actions'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

function FeedContentPage() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const params = useParams()
  const objectId = params?.entityId
  const feedId = params?.feedId
  const objectType = params?.entity
  const {
    login: { user: loggedInUser },
    commonNewsfeed: {
      newsFeedType,
      feeds: { list, loading: feedsLoading, success, loggedUserData },
      entity,
      groupId
    },
    common: { isNative, tagUsersList }
  } = useSelector((state) => state)

  const [backText, setBackText] = useState('')

  const [parentFeedId, setParentFeedId] = useState(0)

  const firstRender = useRef(true)

  useEffect(() => {
    dispatch(commonFeedActions.getFeedBlock(feedId))
    dispatch(moderationReportActions.getFlagReasons())
  }, [])

  useEffect(() => {
    if (!feedsLoading && success && list?.length > 0) {
      if (firstRender.current) {
        setParentFeedId(list[0].id)
        setBackText(getBackText())
        dispatch(commonActions.addUserPageView('feed', list[0].id))
        dispatch(commonActions.getTagUsers('group', groupId))
        if (firstRender.current) {
          firstRender.current = false
          return
        }
      }
    }
  }, [list, feedsLoading, success])

  const handleBack = () => {
    if (objectType === 'group') {
      redirectToPage(`/0/home/group/${objectId}`, isNative)
    } else if (objectType === 'mixr') {
      redirectToPage(`/0/home/event/${objectId}`, isNative)
    } else if (objectType === 'general') {
      redirectToPage(`/0/feed`, isNative)
    }
  }

  const isOrganizer = () => {
    if (loggedUserData) {
      if (objectType === 'group') {
        return loggedUserData.group_role === 'organizer' || loggedUserData.group_role === 'co-organizer'
      } else if (objectType === 'mixr') {
        return loggedUserData.mixr_role === 'organizer' || loggedUserData.mixr_role === 'co-organizer'
      }
    }
    return false
  }

  const isMember = () => {
    if (loggedUserData) {
      if (objectType === 'group') {
        return loggedUserData.group_role !== 'none'
      } else if (objectType === 'mixr') {
        return (
          loggedUserData.mixr_attending !== 'unknown' ||
          loggedUserData.mixr_role !== 'none' ||
          loggedUserData.group_role !== 'none'
        )
      }
    }
    return false
  }

  const getBackText = () => {
    if (entity) {
      if (objectType === 'group') {
        return t('global.backToGroup', { groupName: entity.name })
      } else if (objectType === 'mixr') {
        return t('global.backToMixr', { mixrName: entity.name })
      }
    }
    return null
  }

  return (
    <PageContainer withFooter={false}>
      <div className={styles.backWrapper}>
        <BackNavigation
          className={styles.back}
          customHandleBack={handleBack}
          backText={backText}
          showBackTextMobile={true}
        />
      </div>
      <div className={`${styles.feedsWrapper} ${feedsLoading && styles.feedsWrapperWithLoading}`}>
        <FeedsTabContent
          type={newsFeedType === 'organization' ? 'organization' : newsFeedType}
          entity={{ type: newsFeedType, id: entity?.id, name: entity?.name, picture: '', groupId: groupId }}
          lastFeedRef={null}
          isGroupOrganizer={loggedUserData?.group_role}
          isOrganizer={isOrganizer()}
          isMember={isMember()}
          totalUsers={tagUsersList}
          openAsModal={true}
          feedIdToScroll={feedId}
          loadingFeeds={feedsLoading}
          fromPageFeedContentId={parentFeedId && Number(parentFeedId)}
        />
      </div>
    </PageContainer>
  )
}

export default FeedContentPage
